import _ from 'lodash';
import { createSelector } from 'reselect';

const fetch = (state, props = {}) => _.get(state.fetch, `${props?.resource?.key}`, {});
const fetched = (state, props = {}) => !!_.get(state.fetch, `${props?.resource?.key}.fetched`, false);
const fetching = (state, props = {}) => !!_.get(state.fetch, `${props?.resource?.key}.fetching`, false);
const props = (_, props) => props;
const state = (state) => state;

export const fetchingSelector = createSelector(fetching, (f) => f);
export const fetchedSelector = createSelector(fetched, (f) => f);
export const fetchErrorSelector = createSelector(fetch, (f) => f.error);

export const shouldFetchSelector = createSelector(fetched, fetching, props, state, (fd, fi, props, state) => {
  return !fd && !fi;
});
